import { AddressFormKeyListV2 } from 'components/AddressFormFields/constants'
import { AddressDataV2 } from 'components/AddressFormFields/types'
import { getAddressFieldVersion } from 'components/AddressFormFields/utils'
import { ConfirmRadioValues } from 'constants/Forms'
import { getStringWithoutPrefix } from 'utils/utils'
import { OperationalPrefix } from './constants'
import { BusinessAddressData, BusinessAddressFormData, BusinessAddressFormKey } from './types'

export const getBusinessAddressSavedValue = (
  formKey: BusinessAddressFormKey,
  savedData: BusinessAddressData
) => {
  const { registered, operational } = savedData || {}
  const isOperationalField = formKey?.startsWith(OperationalPrefix)
  const addressTypeKey = getStringWithoutPrefix(formKey, OperationalPrefix)
  const dataKey = getAddressFieldVersion(addressTypeKey, true)
  return isOperationalField ? operational?.[dataKey] : registered?.[dataKey]
}

const getAddressTypePayload = (formValues: BusinessAddressFormData, getOperational?: boolean) => {
  return AddressFormKeyListV2?.reduce((registeredObj, dataKey) => {
    const formKey = getAddressFieldVersion(dataKey)
    const addressTypeKey = getOperational ? `${OperationalPrefix}${formKey}` : formKey
    registeredObj[dataKey] = formValues?.[addressTypeKey] || null
    return registeredObj
  }, {} as AddressDataV2)
}

export const getBusinessAddressPayload = (
  formValues: BusinessAddressFormData
): BusinessAddressData => {
  const hasOperationalAddress = formValues?.isOperationalDifferent === ConfirmRadioValues.YES
  return {
    registered: getAddressTypePayload(formValues),
    operational: hasOperationalAddress ? getAddressTypePayload(formValues, true) : null,
  }
}
